"use strict";

var InputGroup, Mixins, React;

React = require("react");

Mixins = require("../controls/mixins/Mixins");

InputGroup = React.createClass({
  displayName: "InputGroup",

  propTypes: {
    formDef: React.PropTypes.object.isRequired,
    leftComponent: React.PropTypes.object,
    rightComponent: React.PropTypes.object,
    mainComponent: React.PropTypes.object
  },
  render: function render() {
    var leftClass, leftComponent, leftForm, mainComponent, ref, ref1, rightClass, rightComponent, rightForm;
    leftComponent = void 0;
    if (this.props.formDef.leftComponent) {
      leftClass = (ref = this.props.formDef.isLeftButton) != null ? ref : {
        "input-group-btn": "input-group-addon"
      };
      leftForm = this.props.leftComponent;
      leftComponent = React.createElement(
        "span",
        { className: leftClass },
        leftForm
      );
    }
    rightComponent = void 0;
    if (this.props.formDef.rightComponent) {
      rightClass = (ref1 = this.props.formDef.isLeftButton) != null ? ref1 : {
        "input-group-btn": "input-group-addon"
      };
      rightForm = this.props.rightComponent;
      rightComponent = React.createElement(
        "span",
        { className: rightClass },
        rightForm
      );
    }
    mainComponent = this.props.mainComponent;
    return React.createElement(
      "div",
      { className: "input-group" },
      leftComponent,
      mainComponent,
      rightComponent
    );
  }
});

module.exports = InputGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/containers/InputGroup.js
 ** module id = 590
 ** module chunks = 0
 **/